import { render, staticRenderFns } from "./ComplianceFormAttestation.vue?vue&type=template&id=42e7beea&"
import script from "./ComplianceFormAttestation.vue?vue&type=script&lang=js&"
export * from "./ComplianceFormAttestation.vue?vue&type=script&lang=js&"
import style0 from "./ComplianceFormAttestation.vue?vue&type=style&index=0&id=42e7beea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports